<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/AYzFU3/tc-custom/9781667440071.jpg?1673608925183" alt="This image is the cover for the book La vita a terra, Terra e stelle"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">La vita a terra, Terra e stelle
      </h1>
      <p class="bookDescription body article font2">
        <i><b>I ribelli stanno a terra.</b></i> “La vita a terra è pieno zeppo di personaggi indimenticabili e affascinante prosa che fanno pensare ai principali romanzi di formazione come<i>The Dark Beyond the Stars</i> e <i>The Testament of Jessie Lamb</i>, e del genere di narrazione in prima persona piena di tecnologia che farebbe sorridere Andy Weir”. <b><i>~ Dayton Ward, autore bestseller NYT, “Star Trek: Headlong Flight” </i></b> Sessant’anni fa fu creato il Servizio Spaziale degli Stati Uniti, con l’incarico di proteggere la ricchezza e la conoscenza potenzialmente illimitate dello spazio a beneficio dell’intera umanità. Guardiano della tecnologia di fusione e di tutto ciò che è al di sopra dell’atmosfera, il Servizio Spaziale controlla il flusso di persone, materiali e informazioni tra la Terra e le stazioni spaziali, la Luna e Marte. Chiunque sia nello spazio è vincolato al Servizio Spaziale, e tutti gli spaziali appartengono all’élite razziale imposta dal Servizio. Il Servizio Spaziale possiede le stelle… e non intende condividerle.<br/> La diciassettenne Mara Duval, nata nello spazio, era destinata a far parte della prima missione dell’umanità verso le lune di Giove, finché un incidente medico non l’ha lasciata in quarantena a terra per sempre.<br/> Ma terra non è la devastata desolazione che le era stato insegnato a credere, e il Servizio Spaziale sta tenendo in ostaggio il futuro dell’umanità dietro un muro di bugie. Ora Mara sta contrattaccando, trasmettendo video della verità ai suoi amici nello spazio, facendosi sentire ogni volta che può, e condividendo tecnologia e segreti con la sua alleata terricola Jael Alden, una giovane visionaria decisa a sfondare la barriera razziale del Servizio Spaziale.<br/> Sa di non avere molto tempo prima che il Servizio Spaziale si renda conto di quello che sta facendo e la fermi. Ma fino ad allora, Mara intende ricavare il meglio dalla sua vita a terra.<br/> “La
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kevin Killiany, Carmelo Massimo Tidona
      </h2>
      
      <p class="authorDescription body article">Kevin Killiany è stato un attore, un operatore di trivellatrice, un operaio magazziniere, un fotografo e un ragazzo dei giornali. Per la maggior parte della sua vita adulta ha insegnato alla scuola elementare, alle superiori e al community college, è stato un consigliere di intervento per le crisi e ha ricoperto vari ruoli in servizi di supporto alla comunità e sostegno alle famiglie. Ha venduto il suo primo racconto nel 2000 ed è uno scrittore e editor full time dal 2011. Kevin ha scritto per Star Trek, Doctor Who e per diversi giochi di ruolo. Vive con sua moglie Valerie a Wilmington, sulla costa del North Carolina. Hanno quattro figli, uno acquisito di recente, e uno scarabocchio di nipotina di nome Zoë.<br/> Seguite Kevin su Goodreads, e assicuratevi di passare a salutarlo su Facebook  e Twitter.<br/></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Evolved Publishing LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?32802ae0